/**
 * One-shot device location from the browser.
 *
 * This is a manual check-in, not tracking: it only works while Pacer is open and the user
 * grants permission, and captures a single point. Continuous/background location isn't
 * possible from a web app (iOS blocks background geolocation for web pages entirely).
 */
export function getMyLocation(): Promise<{ lat: number; lon: number }> {
  return new Promise((resolve, reject) => {
    if (!('geolocation' in navigator)) {
      reject(new Error('This device has no location support.'));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lon: pos.coords.longitude }),
      (err) => {
        const messages: Record<number, string> = {
          1: 'Location permission was denied — allow it in your browser to share where you are.',
          2: 'Couldn’t get a location fix right now.',
          3: 'Location timed out — try again.',
        };
        reject(new Error(messages[err.code] ?? 'Could not get your location.'));
      },
      { enableHighAccuracy: true, timeout: 12_000, maximumAge: 60_000 },
    );
  });
}

/** A universal maps link for a coordinate (opens the native maps app on phones). */
export function mapLink(lat: number, lon: number): string {
  return `https://maps.google.com/?q=${lat},${lon}`;
}
